module.exports = __webpack_public_path__ + "img/1565246554.33ac98c8.jpg";